import { gql } from "@apollo/client";

export const GET_SHORTLINK = gql`
  query FetchShortlink($shortlinkId: String!) {
    shortlink(shortlinkId: $shortlinkId) {
      id
      url
    }
  }
`;

export const CREATE_SHORTLINK = gql`
  mutation CreateShortlink($url: String!) {
    createShortlink(url: $url) {
      id
      url
    }
  }
`;
